








import Vue from 'vue';
import Questionnaire from '@/components/Questionnaire/Questionnaire.vue';
import SidebarToggle from './SidebarToggle.vue';
import { mapState } from "vuex";
import MapHeader from "./Header.vue";
import {
  RootState
} from "./../../store/types";
export default Vue.extend({
  name: 'Sidebar',

  components: {
    Questionnaire,
    SidebarToggle,
    MapHeader
  },

  computed: {
    ...mapState({
      survey: (state) => (state as RootState).survey,
    }),
  },
});
